import { render, staticRenderFns } from "./paymentAgreement.vue?vue&type=template&id=5f6e9ce4&scoped=true&"
import script from "./paymentAgreement.vue?vue&type=script&lang=js&"
export * from "./paymentAgreement.vue?vue&type=script&lang=js&"
import style0 from "./paymentAgreement.vue?vue&type=style&index=0&id=5f6e9ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e9ce4",
  null
  
)

export default component.exports